import type { AuthUser } from "@/core/auth/session";

export const FUNCTION_LAUNCHER_PATH = "/ung-dung";
export const SUPER_ADMIN_HOME_PATH = "/he-thong/dashboard";
export const WEB_ACCESS_DENIED_MESSAGE =
  "Bạn không có quyền truy cập phần mềm.";

export function canAccessWebApp(
  user: Pick<AuthUser, "webAccessAllowed"> | null | undefined
) {
  return user?.webAccessAllowed === true;
}

export function isWebSuperAdmin(
  user: Pick<AuthUser, "backendRoleKey"> | null | undefined
) {
  return user?.backendRoleKey?.trim().toUpperCase() === "SUPER_ADMIN";
}

/**
 * SUPER_ADMIN uses the standard ERP shell with sidebar navigation. Other web
 * users start from the permission-filtered function launcher.
 */
export function getWebHomePath(user?: Pick<AuthUser, "backendRoleKey"> | null) {
  return !user || isWebSuperAdmin(user)
    ? SUPER_ADMIN_HOME_PATH
    : FUNCTION_LAUNCHER_PATH;
}

export function getPostLoginPath(
  user: Pick<AuthUser, "backendRoleKey"> | null | undefined,
  redirect?: string | null
) {
  return !redirect || redirect === "/" ? getWebHomePath(user) : redirect;
}
